<h1 class="Anton">Bienvenido </h1><p>Proyectos, Informacion, Tutoriales, Contacto.</p>
<br>
<br>
<h3>Listado de proyectos</h3>
<br>
<div class="row row-cols-1 row-cols-md-3 g-4">
  <div class="col">
    <div class="card h-100">
      <img src="assets/images/chat-nodejs.png" class="card-img-top" alt="...">
      <div class="card-body">
        <h5 class="card-title">Chat - Nodejs - PostgreSql</h5>
        <p class="card-text">Este es un proyecto de mensajeria en el cual puedes accceder con tu cuenta y chatear con tus amigos, esta realizado con Node.js como backend y la base de datos esta hecha en PostgreSql.</p>
      </div>
      <div class="card-footer text-center">
        <button class="btn btn-primary">Ver proyecto</button>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="assets/images/nodejs.jpg" class="card-img-top" alt="...">
      <div class="card-body">
        <h5 class="card-title">Peliculas - PHP</h5>
        <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
      </div>
      <div class="card-footer">
        <small class="text-muted">Last updated 3 mins ago</small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="assets/images/php.jpg" class="card-img-top" alt="...">
      <div class="card-body">
        <h5 class="card-title">Lavadoras - PHP</h5>
        <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This card has even longer content than the first to show that equal height action.</p>
      </div>
      <div class="card-footer">
        <small class="text-muted">Last updated 3 mins ago</small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="assets/images/Angular.png" class="card-img-top" alt="...">
      <div class="card-body">
        <h5 class="card-title">Restaurante - PHP</h5>
        <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
      </div>
      <div class="card-footer">
        <small class="text-muted">Last updated 3 mins ago</small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="assets/images/nodejs.jpg" class="card-img-top" alt="...">
      <div class="card-body">
        <h5 class="card-title">Reconocimiento de Plantas - Flutter</h5>
        <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
      </div>
      <div class="card-footer">
        <small class="text-muted">Last updated 3 mins ago</small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="assets/images/php.jpg" class="card-img-top" alt="...">
      <div class="card-body">
        <h5 class="card-title">Parqueadero - Java</h5>
        <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This card has even longer content than the first to show that equal height action.</p>
      </div>
      <div class="card-footer">
        <small class="text-muted">Last updated 3 mins ago</small>
      </div>
    </div>
  </div>
</div>